/** Author-approved Chinese copy, with the same meaning in English. */
export function renderRules(): string {
  return `<div class="rules-copy">
    <p>这是一场关于选择、失去与保留的人生体验。没有标准答案，也没有真正的输赢。
      <span class="en">Explore a lifetime of choices: what you give up, what you lose, and what you hold on to. There are no right answers, winners, or losers.</span></p>
    <p>开局时，每位玩家从 20 张人生底牌中选择 12 张，作为自己这一生最初拥有的底牌。所有人的底牌都是公开的，可以互相查看。
      <span class="en">Choose 12 of your 20 life cards to begin your journey. Everyone plays with an open hand, so you can see one another’s cards.</span></p>
    <p>游戏依次经历六个人生阶段：<span class="en">The game follows six stages of life:</span></p>
    <p class="rules-ages">0–10岁 → 10–20岁 → 20–30岁 → 30–40岁 → 40–50岁 → 51岁以上
      <span class="en">Ages 0–10 → 10–20 → 20–30 → 30–40 → 40–50 → 51+</span></p>
    <p>每个阶段都包含两个环节：<span class="en">Each stage has two parts:</span></p>
    <h3>1. 挫折牌<span class="en">1. Setback cards</span></h3>
    <p>玩家按顺序轮流行动。轮到你时，从当前年龄阶段的挫折牌中不放回抽取 1 张，并选择：
      <span class="en">Take turns in order. When it’s your turn, draw a setback card for this stage of life. Keep it out of the deck, then choose:</span></p>
    <ul>
      <li>接受：保留这张挫折牌。如果你认为它与你当前的人生底牌有冲突，可以舍弃 0～1 张冲突底牌。
        <span class="en">Accept: keep the setback card. If you feel it conflicts with your current life cards, you may discard zero or one conflicting life card.</span></li>
      <li>拒绝：不接受这次挫折，但必须舍弃 2 张人生底牌作为代价。
        <span class="en">Reject: turn down the setback by giving up exactly two life cards.</span></li>
    </ul>
    <p>你的选择过程是公开的，其他玩家可以实时看到你正在考虑舍弃哪些牌。确认后，结果才正式生效。
      <span class="en">Your choices are public. Other players can see which cards you are considering discarding in real time. The result becomes official only after you confirm.</span></p>
    <p>完成选择后，可以和其他玩家交流你的理由和感受，再结束回合，轮到下一位玩家。
      <span class="en">After making your choice, share your reasons and feelings with the other players. Then end your turn so the next player can act.</span></p>
    <h3>2. 问答牌<span class="en">2. Question cards</span></h3>
    <p>所有人完成挫折牌环节后，再按顺序进行问答。
      <span class="en">Once everyone has finished their setback turn, take question turns in the same order.</span></p>
    <p>每位玩家抽取 3 张当前年龄阶段的问答牌并回答，其他玩家也可以参与讨论。
      <span class="en">Each player draws and answers three question cards for the current age stage. Other players are welcome to join the discussion.</span></p>
    <p>所有人完成后，进入下一个年龄阶段。
      <span class="en">When everyone has finished, move to the next age stage.</span></p>
    <h3>游戏结束<span class="en">At the end of the game</span></h3>
    <p>完成全部六个人生阶段后，回顾自己：<span class="en">After all six stages, look back on:</span></p>
    <ul>
      <li>最初选择了什么；<span class="en">What you chose at the beginning;</span></li>
      <li>最后还剩下什么；<span class="en">What you still hold at the end;</span></li>
      <li>哪些底牌是在接受挫折时失去的；<span class="en">Which life cards you lost when accepting setbacks;</span></li>
      <li>哪些是为了拒绝挫折主动舍弃的；<span class="en">Which you chose to give up to reject setbacks;</span></li>
      <li>自己经历了怎样的一生。<span class="en">The story of the life you lived.</span></li>
    </ul>
    <p class="rules-closing">这不是人格测试，而是一场人生取舍实验。<br>看看走到最后，你最想留下的到底是什么。
      <span class="en">This is not a personality test. It is an experiment in the choices and trade-offs of life.<br>See what you most want to hold on to when you reach the end.</span></p>
  </div>`;
}
